import scrollIntoView from 'scroll-into-view-if-needed';

interface AjaxResponse {
    snippets: object;
    scrollTo?: string;
}

export class AutoScrollExtension {
    public constructor(naja: any) {
        naja.addEventListener('success', (event: {response: AjaxResponse}) => {
            const response = event.response;

            if (response.scrollTo === undefined) {
                return;
            }

            const scrollTarget = document.querySelector(response.scrollTo);

            if (scrollTarget === null) {
                return;
            }

            scrollIntoView(scrollTarget, {
                behavior: 'smooth',
                scrollMode: 'if-needed',
                block: 'start',
            });
        });
    }
}
